function parseNumber(str) {
  return parseInt(str.replace(/[,. ]/g, ""), 10);
}

function formatNumber(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function startTicker(tickerElement) {
  let originalValue = tickerElement.innerText.trim();
  let currentNumber = parseNumber(originalValue);

  const decrementValue = 180;
  const duration = 3 * 60;
  let secondsElapsed = 0;

  if (isNaN(currentNumber) || currentNumber < decrementValue) {
    return;
  }

  if (currentNumber > decrementValue) {
    currentNumber -= decrementValue;
    tickerElement.innerText = formatNumber(currentNumber);
  }

  const timer = setInterval(() => {
    if (secondsElapsed < duration) {
      currentNumber += 1;
      tickerElement.innerText = formatNumber(currentNumber);
      secondsElapsed++;
    } else {
      clearInterval(timer);
    }
  }, 1000);
}

(function () {
  const tickers = document.querySelectorAll(".ticker");
  tickers.forEach((tickerElement) => startTicker(tickerElement));
})();
